import { useParams } from "react-router-dom";

import SuggestionView from "@/components/SuggestionView";

export default function SuggestionDetailPage() {
  const params = useParams();
  return (
    <main className="px-6 py-10">
      <SuggestionView slug={String(params.skillSlug)} id={String(params.suggestionId)} />
    </main>
  );
}
